// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/dist/js/" + chunkId + "." + {"134":"54aed946","223":"2749c800","289":"a80e1a13","594":"8014002a","701":"bfe44cde","758":"577b6ec2","818":"2bf09161"}[chunkId] + ".js";
};